<script setup lang="ts">
import InputNumber from 'primevue/inputnumber'
defineProps<{label:string;modelValue:number;min?:number;max?:number;step?:number;suffix?:string;disabled?:boolean}>()
const emit=defineEmits<{(e:'update:modelValue',value:number):void}>()
</script>
<template><label class="number-field"><span>{{label}}</span><InputNumber :model-value="modelValue" @update:model-value="v=>v!==null&&emit('update:modelValue',v)" :min="min" :max="max" :step="step??1" :suffix="suffix" :min-fraction-digits="0" :max-fraction-digits="4" :disabled="disabled" :use-grouping="false" size="small" fluid /></label></template>
